// 部署环境配置项

const globalPath = {
    jsonPath: '/gemp-emap-zmq/',
}

module.exports = globalPath